import { StateCreator } from 'zustand';

export interface UISliceState {
  isInitializing: boolean;
  isApplyingPromo: boolean;
  isGettingPricingInfo: boolean;
  isGettingShippingInfo: boolean;
  isPlacingOrder: boolean;
  isVerifyingAddress: boolean;
  canPlaceOrder: boolean;
  showExpressOverlay: boolean;
}

interface UISliceActions {
  setIsInitializing: (isInitializing: boolean) => void;
  setIsApplyingPromo: (isApplyingPromo: boolean) => void;
  setIsGettingPricingInfo: (isGettingPricingInfo: boolean) => void;
  setIsGettingShippingInfo: (isGettingShippingInfo: boolean) => void;
  setIsPlacingOrder: (isPlacingOrder: boolean) => void;
  setIsVerifyingAddress: (isVerifyingAddress: boolean) => void;
  setCanPlaceOrder: (canPlaceOrder: boolean) => void;
  setShowExpressOverlay: (showExpressOverlay: boolean) => void;
  resetUI: () => void;
}

const defaultState: UISliceState = {
  isInitializing: true,
  isApplyingPromo: false,
  isGettingPricingInfo: false,
  isGettingShippingInfo: false,
  isPlacingOrder: false,
  isVerifyingAddress: false,
  canPlaceOrder: false,
  showExpressOverlay: false,
};

export type UISlice = UISliceState & UISliceActions;

export const createUISlice: StateCreator<UISlice, [], [], UISlice> = (set) => ({
  ...defaultState,
  setIsInitializing: (isInitializing: boolean) => set({ isInitializing }),
  setIsApplyingPromo: (isApplyingPromo: boolean) => set({ isApplyingPromo }),
  setIsGettingPricingInfo: (isGettingPricingInfo: boolean) => set({ isGettingPricingInfo }),
  setIsGettingShippingInfo: (isGettingShippingInfo: boolean) => set({ isGettingShippingInfo }),
  setIsPlacingOrder: (isPlacingOrder: boolean) => set({ isPlacingOrder }),
  setIsVerifyingAddress: (isVerifyingAddress: boolean) => set({ isVerifyingAddress }),
  setCanPlaceOrder: (canPlaceOrder: boolean) => set({ canPlaceOrder }),
  setShowExpressOverlay: (showExpressOverlay: boolean) => set({ showExpressOverlay }),
  resetUI: () => set(defaultState),
});
